"use client";

import { c as _c } from "react/compiler-runtime";
import { RegularLinkButton } from "@/components/Button/RegularLinkButton/RegularLinkButton.component";
import { TrialFocusPaywallTitle } from "@/components/Paywall/_components/PaywallTitle/TrialFocusPaywallTitle.component";
import { Translation } from "@/components/Translation/Translation.component";
import { usePaywall } from "@/contexts/paywall/paywall.context";
import { useSite } from "@/contexts/site/site.context";
import { useCurrentUrl } from "@/hooks/use-current-url.hook";
import { useAuthentication } from "@/vendors/authentication/hooks/use-authentication.hook";
export function CreateTrialCard() {
  const $ = _c(17);
  const {
    relative: currentUrl
  } = useCurrentUrl();
  const {
    name: siteName,
    subscription: t0
  } = useSite();
  const {
    trialDays
  } = t0;
  const {
    urls
  } = useAuthentication();
  const {
    trial
  } = usePaywall();
  let t1;
  if ($[0] !== currentUrl || $[1] !== urls) {
    t1 = urls?.createTrial(currentUrl) ?? null;
    $[0] = currentUrl;
    $[1] = urls;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const trialUrl = t1;
  const isTrialExpired = trial?.isUserTrialExpired ?? false;
  if (trialUrl === null || isTrialExpired) {
    return null;
  }
  const t2 = `Prøv ${siteName} gratis i ${trialDays} dage`;
  const t3 = `Testen Sie ${siteName} ${trialDays} Tage lang kostenlos`;
  const t4 = `Try ${siteName} for free for ${trialDays} days`;
  const t5 = `Prøv ${siteName} gratis i ${trialDays} dager`;
  const t6 = `Prova ${siteName} gratis i ${trialDays} dagar`;
  let t7;
  if ($[3] !== t2 || $[4] !== t3 || $[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
    t7 = <TrialFocusPaywallTitle model={{
      da: t2,
      de: t3,
      en: t4,
      no: t5,
      sv: t6
    }} />;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="max-w-sm"><Translation da={"Fuld adgang for \xE9n bruger - helt uden kreditkortoplysninger"} de={"Voller Zugriff f\xFCr einen Benutzer - ganz ohne Kreditkarteninformationen"} en="Full access for one user - no credit card information required" no={"Full tilgang for \xE9n bruker - helt uten kredittkortinformasjon"} sv={"Full tillg\xE5ng f\xF6r en anv\xE4ndare - helt utan kreditkortsinformation"} /></div>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t10;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      contentId: "create-trial",
      contentSource: "paywall",
      contentType: "cta"
    };
    t10 = <Translation da={"Pr\xF8v nu"} de="Jetzt testen" en="Try now" no={"Pr\xF8v n\xE5"} sv="Prova nu" />;
    $[10] = t10;
    $[11] = t9;
  } else {
    t10 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[12] !== trialUrl) {
    t11 = <RegularLinkButton className="w-full" href={trialUrl} position="pw-ct-tr-btn" testId="unauthenticated-trial-focus-button" trackingModel={t9}>{t10}</RegularLinkButton>;
    $[12] = trialUrl;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11 || $[15] !== t7) {
    t12 = <div className="flex flex-col items-center gap-2">{t7}{t8}{t11}</div>;
    $[14] = t11;
    $[15] = t7;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  return t12;
}